import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4 max-w-4xl">
        <button
          onClick={() => navigate(-1)}
          className="mb-6 flex items-center text-purple-600 hover:text-purple-800 transition-colors"
        >
          <ArrowLeft className="w-5 h-5 mr-2" />
          Back
        </button>

        <div className="bg-white rounded-lg shadow-md p-8">
          <h1 className="text-3xl font-bold text-center mb-8">Privacy Policy</h1>
          <p className="text-gray-500 text-center mb-8">Effective Date: April 30, 2025</p>

          <div className="prose max-w-none">
            <p className="font-bold text-red-600 mb-4 text-center">
              FOR ENTERTAINMENT PURPOSES ONLY
            </p>
            
            <p>
              At PsychicsInsights.com, your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your information when you use our website and services.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">1. Information We Collect</h2>
            <p>
              We may collect the following types of information:
            </p>
            <h3 className="text-lg font-medium mt-4 mb-2">a. Personal Information</h3>
            <p>
              When you register or use our services, we collect personal details such as:
            </p>
            <ul>
              <li>Name</li>
              <li>Email address</li>
              <li>Payment information (via Stripe)</li>
              <li>Date of birth (to verify age)</li>
              <li>Chat history with advisors</li>
            </ul>

            <h3 className="text-lg font-medium mt-4 mb-2">b. Usage Data</h3>
            <p>
              We may collect anonymous data about your device, browser, IP address, time zone, and how you use the site (pages visited, actions taken, etc.).
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">2. How We Use Your Information</h2>
            <p>
              We use your information to:
            </p>
            <ul>
              <li>Provide and manage your account</li>
              <li>Facilitate payments through Stripe</li>
              <li>Connect you with advisors</li>
              <li>Improve our platform and services</li>
              <li>Send important account or service-related notifications</li>
            </ul>
            <p>
              We do not sell or rent your personal information to third parties.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">3. Payments</h2>
            <p>
              All transactions are securely processed through Stripe. We do not store your full credit card number or billing information on our servers.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">4. Cookies & Tracking</h2>
            <p>
              We use cookies and similar technologies to enhance your browsing experience, remember your preferences, and analyze site traffic. You may disable cookies in your browser settings, but doing so may affect functionality.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">5. Sharing of Information</h2>
            <p>
              We may share your data with:
            </p>
            <ul>
              <li>Service providers (e.g. payment processors, hosting platforms)</li>
              <li>Legal authorities, if required by law or to enforce our Terms of Service</li>
              <li>Advisors, only to the extent necessary to provide the requested service</li>
            </ul>

            <h2 className="text-xl font-semibold mt-8 mb-4">6. Your Choices</h2>
            <p>
              You may:
            </p>
            <ul>
              <li>Access or update your personal information by logging into your account</li>
              <li>Request account deletion by emailing psychicsinsights@gmail.com</li>
              <li>Unsubscribe from promotional emails at any time using the unsubscribe link</li>
            </ul>

            <h2 className="text-xl font-semibold mt-8 mb-4">7. Data Security</h2>
            <p>
              We implement reasonable technical and organizational safeguards to protect your data. However, no online service is 100% secure, and you use the platform at your own risk.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">8. Age Restriction</h2>
            <p>
              Our services are only intended for users who are 18 years or older. We do not knowingly collect data from individuals under 18. If we discover such information has been collected, we will delete it.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">9. Third-Party Links</h2>
            <p>
              Our site may contain links to third-party sites. We are not responsible for the privacy practices or content of those websites.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">10. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy periodically. Updates will be posted on this page with the new effective date. Continued use of the platform indicates your acceptance of the updated policy.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">11. Contact Us</h2>
            <p>
              If you have any questions or concerns about your privacy, contact us at:<br />
              Email: psychicsinsights@gmail.com<br />
              Website: www.psychicsinsights.com
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;